module.exports = __webpack_public_path__ + "static/media/categories_step_1_1.343ffbd2.svg";